import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login }               = useAuth();
  const navigate                = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError('Email o contraseña incorrectos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight:'100vh', background:'#f5f5f5',
      display:'flex', alignItems:'center', justifyContent:'center',
      fontFamily:'Inter,-apple-system,sans-serif'
    }}>
      <div style={{
        background:'#ffffff', border:'1px solid #e0e0e0',
        borderRadius:'12px', padding:'40px', width:'100%', maxWidth:'400px',
        boxShadow:'0 2px 16px rgba(0,0,0,0.06)'
      }}>
        {/* Logo */}
        <div style={{textAlign:'center', marginBottom:'32px'}}>
          <img src="/logo192.png" alt="Rocket Tech"
            style={{width:'64px', height:'64px', margin:'0 auto 16px', display:'block', borderRadius:'50%'}}
          />
          <h1 style={{color:'#1a1a1a', fontSize:'20px', fontWeight:'600', margin:'0 0 4px'}}>
            SepManager
          </h1>
          <p style={{color:'#a0a0a0', fontSize:'13px', margin:0}}>
            Rocket Tech S.A.S — Sistema de Ensayos
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{marginBottom:'16px'}}>
            <label style={{display:'block', color:'#6b6b6b', fontSize:'12px', marginBottom:'6px'}}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{
                width:'100%', padding:'10px 12px',
                background:'#f5f5f5', border:'1px solid #e0e0e0',
                borderRadius:'8px', color:'#1a1a1a', fontSize:'14px',
                outline:'none', boxSizing:'border-box'
              }}
              placeholder="usuario@empresa.com"
            />
          </div>

          <div style={{marginBottom:'24px'}}>
            <label style={{display:'block', color:'#6b6b6b', fontSize:'12px', marginBottom:'6px'}}>
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{
                width:'100%', padding:'10px 12px',
                background:'#f5f5f5', border:'1px solid #e0e0e0',
                borderRadius:'8px', color:'#1a1a1a', fontSize:'14px',
                outline:'none', boxSizing:'border-box'
              }}
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div style={{
              background:'#fef2f2', border:'1px solid #ef4444',
              borderRadius:'6px', padding:'10px 12px',
              color:'#dc2626', fontSize:'13px', marginBottom:'16px'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width:'100%', padding:'11px',
              background: loading ? '#d0d0d0' : '#1a1a1a',
              border:'none', borderRadius:'8px',
              color:'#ffffff', fontSize:'14px', fontWeight:'600',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>

        <p style={{
          textAlign:'center', color:'#a0a0a0', fontSize:'11px', marginTop:'24px'
        }}>
          Performance SRL · PAE · Rocket Tech S.A.S
        </p>
      </div>
    </div>
  );
}
